import type { Resource } from '../../';
export const country_countries_EE: Resource = {"default":"Estonia"};
